// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { ScreensNames } from '@front/controls/UtilsClasses/FactoryConstants';
import { TerceraChangePasswordScreen } from '@front/controls/screen/TerceraChangePasswordScreen';
import InvestingChangePasswordScreenTemplate from '../TradingPlatformTemplates/InvestingChangePasswordScreenTemplate.html';
export class InvestingChangePasswordScreen extends TerceraChangePasswordScreen {
    constructor() {
        super();
        // void this.set({ width: 312, height: 458 }); // screen sizes set in .investing-change-password-screen class
    }
    getType() {
        return ScreensNames.InvestingChangePasswordScreen;
    }
    hidePasswords() {
        void super.set({
            curPassHided: true,
            newPassHided: true,
            confirmPassHided: true
        });
    }
    closeScreenEventClick(_sender, fromOk = false) {
        if (!fromOk && this.cancelCallBack != null) {
            this.cancelCallBack();
        }
        void super.set({ visible: false });
    }
}
TerceraChangePasswordScreen.extendWith(InvestingChangePasswordScreen, {
    template: InvestingChangePasswordScreenTemplate,
    data: function () {
        return {
            curPassHided: true,
            newPassHided: true,
            confirmPassHided: true,
            visible: false
        };
    }
});
